var exports = {
  "container": "xcc377c0b--4616d1--container",
  "image": "xcc377c0b--4616d1--image",
  "not-found": "xcc377c0b--4616d1--not-found",
  "start": "xcc377c0b--4616d1--start",
  "title": "xcc377c0b--4616d1--title",
};

module.exports = exports;
